export default __webpack_public_path__ + "static/media/logo.80d79c8a.png";